/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Title_TaskInputs */

const cs_templates_use_picker_title_task = /** @type {(inputs: Templates_Use_Picker_Title_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte úkol prohlídky`)
};

const en_templates_use_picker_title_task = /** @type {(inputs: Templates_Use_Picker_Title_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a viewing task`)
};

/**
* | output |
* | --- |
* | "Choose a viewing task" |
*
* @param {Templates_Use_Picker_Title_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_title_task = /** @type {((inputs?: Templates_Use_Picker_Title_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Title_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_title_task(inputs)
	return cs_templates_use_picker_title_task(inputs)
});